import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { WA, SITE } from "../data/site";

const labelCls = "text-xs font-semibold uppercase tracking-[0.2em] text-saga-ink/70";
const inputCls =
    "mt-2 w-full rounded-md border border-saga-red/25 bg-saga-creamlight px-3 py-2 text-sm text-saga-ink placeholder:text-saga-ink/40 focus:outline-none focus:ring-1 focus:ring-saga-red/50";

const ContactForm = () => {
    const [form, setForm] = useState({ name: "", phone: "", email: "", message: "", company: "" });
    const [sending, setSending] = useState(false);
    const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        if (form.company) return;
        if (!form.name.trim() || !form.message.trim()) {
            toast.error("Please fill in your name and message.");
            return;
        }
        setSending(true);
        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/enquiries`, {
                name: form.name.trim(),
                phone: form.phone.trim(),
                email: form.email.trim(),
                message: form.message.trim(),
            });
            window.open(WA.enquiry(form), "_blank", "noopener");
            toast.success("Enquiry sent! WhatsApp opened too — we'll reply as quickly as possible.");
            setForm({ name: "", phone: "", email: "", message: "", company: "" });
        } catch {
            toast.error("Could not send your enquiry right now. Please reach us on WhatsApp instead.");
        } finally {
            setSending(false);
        }
    };

    return (
        <form data-testid="contact-form" className="space-y-6" onSubmit={submit} noValidate>
            <input
                type="text"
                name="company"
                value={form.company}
                onChange={set("company")}
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="hidden"
            />
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                <div>
                    <label className={labelCls} htmlFor="contact-name">
                        Name *
                    </label>
                    <input
                        id="contact-name"
                        data-testid="contact-name-input"
                        className={inputCls}
                        placeholder="Your name"
                        value={form.name}
                        onChange={set("name")}
                        required
                    />
                </div>
                <div>
                    <label className={labelCls} htmlFor="contact-phone">
                        Phone
                    </label>
                    <input
                        id="contact-phone"
                        data-testid="contact-phone-input"
                        className={inputCls}
                        placeholder="+91 ..."
                        value={form.phone}
                        onChange={set("phone")}
                    />
                </div>
            </div>
            <div>
                <label className={labelCls} htmlFor="contact-email">
                    Email
                </label>
                <input
                    id="contact-email"
                    data-testid="contact-email-input"
                    type="email"
                    className={inputCls}
                    placeholder="you@example.com"
                    value={form.email}
                    onChange={set("email")}
                />
            </div>
            <div>
                <label className={labelCls} htmlFor="contact-message">
                    Message *
                </label>
                <textarea
                    id="contact-message"
                    data-testid="contact-message-input"
                    className={`${inputCls} min-h-[60px] py-2`}
                    placeholder="Tell us what you'd like to know — menu, party orders, anything."
                    rows={4}
                    value={form.message}
                    onChange={set("message")}
                    required
                />
            </div>
            <button
                type="submit"
                data-testid="contact-submit-btn"
                disabled={sending}
                className="w-full rounded-full bg-saga-red px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-saga-cream transition-colors hover:bg-saga-reddeep disabled:opacity-60 sm:w-auto"
            >
                {sending ? "Sending..." : "Send Enquiry"}
            </button>
        </form>
    );
};

export default ContactForm;
